export const sleepClinicConstant = {
    GET: 'SLEEP_DIAGNOSTIC_CLINIC_GET'
};
